import { FC } from "react";
import styled from "styled-components";

export const BotChatStreamingMessageAvatarContainer = styled.div`
  ${((props) => props?.theme?.themeConfig?.chatMessages?.botMessage?.avatar?.styles)}
  img {
    width: 35px;
    height: 35px;
  }
`

export const BotChatStreamingMessageAvatar: FC<{ src: string }> = ({ src }) => (
  <BotChatStreamingMessageAvatarContainer className="voa_avatar_container">
    <img src={src} width={40} height={40} className="voa_avatar_image" 
    style={{ borderRadius: "50%" ,margin : '5px', objectFit: 'scale-down' }}
    />
  </BotChatStreamingMessageAvatarContainer>
);